<template>
	<app-page>
		<div class="main-title">
			中华人民共和国企业所得税法实施条例
		</div>
		<div class="flex flex-end clearfix">
			<el-button type="primary" @click="goback()">返回</el-button>
		</div>
		<div class="detail-content">
			<div data-v-bbdef3ee="" class="detail-content">
				<p style="text-align:center;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#999999"
									>中华人民共和国国务院令[2007]512号</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"
									>《中华人民共和国企业所得税法实施条例》已经2007年11月28日国务院第197次常务会议通过，现予公布，自2008年1月1日起施行。</span
								></span
							></span
						></span
					>
				</p>
				<p style="text-align:right;"></p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">总 理 温家宝</span></span
							></span
						></span
					>
				</p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 二○○七年十二月六日</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p></p>
				<p
					style="text-align:left;"
					size="0"
					_root="undefined"
					__ownerid="undefined"
					__hash="undefined"
					__altered="false"
				>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"
									>中华人民共和国企业所得税法实施条例</span
								></span
							></span
						></span
					>
				</p>
				<p
					style="text-align:left;"
					size="0"
					_root="undefined"
					__ownerid="undefined"
					__hash="undefined"
					__altered="false"
				></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第一章 总 则</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一条
									根据《中华人民共和国企业所得税法》（以下简称企业所得税法）的规定，制定本条例。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二条
									企业所得税法第一条所称个人独资企业、合伙企业，是指依照中国法律、行政法规成立的个人独资企业、合伙企业。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三条
									企业所得税法第二条所称依法在中国境内成立的企业，包括依照中国法律、行政法规在中国境内成立的企业、事业单位、社会团体以及其他取得收入的组织。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第二条所称依照外国（地区）法律成立的企业，包括依照外国（地区）法律成立的企业和其他取得收入的组织。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四条
									企业所得税法第二条所称实际管理机构，是指对企业的生产经营、人员、账务、财产等实施实质性全面管理和控制的机构。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五条
									企业所得税法第二条第三款所称机构、场所，是指在中国境内从事生产经营活动的机构、场所，包括：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）管理机构、营业机构、办事机构；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）工厂、农场、开采自然资源的场所；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）提供劳务的场所；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）从事建筑、安装、装配、修理、勘探等工程作业的场所；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）其他从事生产经营活动的机构、场所。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									非居民企业委托营业代理人在中国境内从事生产经营活动的，包括委托单位或者个人经常代其签订合同，或者储存、交付货物等，该营业代理人视为非居民企业在中国境内设立的机构、场所。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六条
									企业所得税法第三条所称所得，包括销售货物所得、提供劳务所得、转让财产所得、股息红利等权益性投资所得、利息所得、租金所得、特许权使用费所得、接受捐赠所得和其他所得。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七条
									企业所得税法第三条所称来源于中国境内、境外的所得，按照以下原则确定：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）销售货物所得，按照交易活动发生地确定；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）提供劳务所得，按照劳务发生地确定；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）转让财产所得，不动产转让所得按照不动产所在地确定，动产转让所得按照转让动产的企业或者机构、场所所在地确定，权益性投资资产转让所得按照被投资企业所在地确定；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）股息、红利等权益性投资所得，按照分配所得的企业所在地确定；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）利息所得、租金所得、特许权使用费所得，按照负担、支付所得的企业或者机构、场所所在地确定，或者按照负担、支付所得的个人的住所地确定；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（六）其他所得，由国务院财政、税务主管部门确定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八条
									企业所得税法第三条所称实际联系，是指非居民企业在中国境内设立的机构、场所拥有据以取得所得的股权、债权，以及拥有、管理、控制据以取得所得的财产等。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第二章 应纳税所得额</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第一节 一般规定</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九条
									企业应纳税所得额的计算，以权责发生制为原则，属于当期的收入和费用，不论款项是否收付，均作为当期的收入和费用；不属于当期的收入和费用，即使款项已经在当期收付，均不作为当期的收入和费用。本条例和国务院财政、税务主管部门另有规定的除外。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十条
									企业所得税法第五条所称亏损，是指企业依照企业所得税法和本条例的规定将每一纳税年度的收入总额减除不征税收入、免税收入和各项扣除后小于零的数额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十一条
									企业所得税法第五十五条所称清算所得，是指企业的全部资产可变现价值或者交易价格减除资产净值、清算费用以及相关税费等后的余额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									投资方企业从被清算企业分得的剩余资产，其中相当于从被清算企业累计未分配利润和累计盈余公积中应当分得的部分，应当确认为股息所得；剩余资产减除上述股息所得后的余额，超过或者低于投资成本的部分，应当确认为投资资产转让所得或者损失。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第二节 收 入</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十二条
									企业所得税法第六条所称企业取得收入的货币形式，包括现金、存款、应收账款、应收票据、准备持有至到期的债券投资以及债务的豁免等。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第六条所称企业取得收入的非货币形式，包括固定资产、生物资产、无形资产、股权投资、存货、不准备持有至到期的债券投资、劳务以及有关权益等。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十三条
									企业所得税法第六条所称企业以非货币形式取得的收入，应当按照公允价值确定收入额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									前款所称公允价值，是指按照市场价格确定的价值。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十四条
									企业所得税法第六条第（一）项所称销售货物收入，是指企业销售商品、产品、原材料、包装物、低值易耗品以及其他存货取得的收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十五条
									企业所得税法第六条第（二）项所称提供劳务收入，是指企业从事建筑安装、修理修配、交通运输、仓储租赁、金融保险、邮电通信、咨询经纪、文化体育、科学研究、技术服务、教育培训、餐饮住宿、中介代理、卫生保健、社区服务、旅游、娱乐、加工以及其他劳务服务活动取得的收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十六条
									企业所得税法第六条第（三）项所称转让财产收入，是指企业转让固定资产、生物资产、无形资产、股权、债权等财产取得的收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十七条
									企业所得税法第六条第（四）项所称股息、红利等权益性投资收益，是指企业因权益性投资从被投资方取得的收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									股息、红利等权益性投资收益，除国务院财政、税务主管部门另有规定外，按照被投资方作出利润分配决定的日期确认收入的实现。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十八条
									企业所得税法第六条第（五）项所称利息收入，是指企业将资金提供他人使用但不构成权益性投资，或者因他人占用本企业资金取得的收入，包括存款利息、贷款利息、债券利息、欠款利息等收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									利息收入，按照合同约定的债务人应付利息的日期确认收入的实现。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第十九条
									企业所得税法第六条第（六）项所称租金收入，是指企业提供固定资产、包装物或者其他有形资产的使用权取得的收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									租金收入，按照合同约定的承租人应付租金的日期确认收入的实现。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十条
									企业所得税法第六条第（七）项所称特许权使用费收入，是指企业提供专利权、非专利技术、商标权、著作权以及其他特许权的使用权取得的收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									特许权使用费收入，按照合同约定的特许权使用人应付特许权使用费的日期确认收入的实现。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十一条
									企业所得税法第六条第（八）项所称接受捐赠收入，是指企业接受的来自其他企业、组织或者个人无偿给予的货币性资产、非货币性资产。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									接受捐赠收入，按照实际收到捐赠资产的日期确认收入的实现。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十二条
									企业所得税法第六条第（九）项所称其他收入，是指企业取得的除企业所得税法第六条第（一）项至第（八）项规定的收入外的其他收入，包括企业资产溢余收入、逾期未退包装物押金收入、确实无法偿付的应付款项、已作坏账损失处理后又收回的应收款项、债务重组收入、补贴收入、违约金收入、汇兑收益等。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十三条
									企业的下列生产经营业务可以分期确认收入的实现：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）以分期收款方式销售货物的，按照合同约定的收款日期确认收入的实现；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）企业受托加工制造大型机械设备、船舶、飞机，以及从事建筑、安装、装配工程业务或者提供其他劳务等，持续时间超过12个月的，按照纳税年度内完工进度或者完成的工作量确认收入的实现。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十四条
									采取产品分成方式取得收入的，按照企业分得产品的日期确认收入的实现，其收入额按照产品的公允价值确定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十五条
									企业发生非货币性资产交换，以及将货物、财产、劳务用于捐赠、偿债、赞助、集资、广告、样品、职工福利或者利润分配等用途的，应当视同销售货物、转让财产或者提供劳务，但国务院财政、税务主管部门另有规定的除外。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十六条
									企业所得税法第七条第（一）项所称财政拨款，是指各级人民政府对纳入预算管理的事业单位、社会团体等组织拨付的财政资金，但国务院和国务院财政、税务主管部门另有规定的除外。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第七条第（二）项所称行政事业性收费，是指依照法律法规等有关规定，按照国务院规定程序批准，在实施社会公共管理，以及在向公民、法人或者其他组织提供特定公共服务过程中，向特定对象收取并纳入财政管理的费用。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第七条第（二）项所称政府性基金，是指企业依照法律、行政法规等有关规定，代政府收取的具有专项用途的财政资金。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第七条第（三）项所称国务院规定的其他不征税收入，是指企业取得的，由国务院财政、税务主管部门规定专项用途并经国务院批准的财政性资金。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第三节 扣 除</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十七条
									企业所得税法第八条所称有关的支出，是指与取得收入直接相关的支出。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第八条所称合理的支出，是指符合生产经营活动常规，应当计入当期损益或者有关资产成本的必要和正常的支出。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十八条
									企业发生的支出应当区分收益性支出和资本性支出。收益性支出在发生当期直接扣除；资本性支出应当分期扣除或者计入有关资产成本，不得在发生当期直接扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业的不征税收入用于支出所形成的费用或者财产，不得扣除或者计算对应的折旧、摊销扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									除企业所得税法和本条例另有规定外，企业实际发生的成本、费用、税金、损失和其他支出，不得重复扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第二十九条
									企业所得税法第八条所称成本，是指企业在生产经营活动中发生的销售成本、销货成本、业务支出以及其他耗费。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十条
									企业所得税法第八条所称费用，是指企业在生产经营活动中发生的销售费用、管理费用和财务费用，已经计入成本的有关费用除外。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十一条
									企业所得税法第八条所称税金，是指企业发生的除企业所得税和允许抵扣的增值税以外的各项税金及其附加。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十二条
									企业所得税法第八条所称损失，是指企业在生产经营活动中发生的固定资产和存货的盘亏、毁损、报废损失，转让财产损失，呆账损失，坏账损失，自然灾害等不可抗力因素造成的损失以及其他损失。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业发生的损失，减除责任人赔偿和保险赔款后的余额，依照国务院财政、税务主管部门的规定扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业已经作为损失处理的资产，在以后纳税年度又全部收回或者部分收回时，应当计入当期收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十三条
									企业所得税法第八条所称其他支出，是指除成本、费用、税金、损失外，企业在生产经营活动中发生的与生产经营活动有关的、合理的支出。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十四条 企业发生的合理的工资薪金支出，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									前款所称工资薪金，是指企业每一纳税年度支付给在本企业任职或者受雇的员工的所有现金形式或者非现金形式的劳动报酬，包括基本工资、奖金、津贴、补贴、年终加薪、加班工资，以及与员工任职或者受雇有关的其他支出。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十五条
									企业依照国务院有关主管部门或者省级人民政府规定的范围和标准为职工缴纳的基本养老保险费、基本医疗保险费、失业保险费、工伤保险费、生育保险费等基本社会保险费和住房公积金，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业为投资者或者职工支付的补充养老保险费、补充医疗保险费，在国务院财政、税务主管部门规定的范围和标准内，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十六条
									除企业依照国家有关规定为特殊工种职工支付的人身安全保险费和国务院财政、税务主管部门规定可以扣除的其他商业保险费外，企业为投资者或者职工支付的商业保险费，不得扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十七条
									企业在生产经营活动中发生的合理的不需要资本化的借款费用，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业为购置、建造固定资产、无形资产和经过12个月以上的建造才能达到预定可销售状态的存货发生借款的，在有关资产购置、建造期间发生的合理的借款费用，应当作为资本性支出计入有关资产的成本，并依照本条例的规定扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十八条
									企业在生产经营活动中发生的下列利息支出，准予扣除：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）非金融企业向金融企业借款的利息支出、金融企业的各项存款利息支出和同业拆借利息支出、企业经批准发行债券的利息支出；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）非金融企业向非金融企业借款的利息支出，不超过按照金融企业同期同类贷款利率计算的数额的部分。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第三十九条
									企业在货币交易中，以及纳税年度终了时将人民币以外的货币性资产、负债按照期末即期人民币汇率中间价折算为人民币时产生的汇兑损失，除已经计入有关资产成本以及与向所有者进行利润分配相关的部分外，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十条
									企业发生的职工福利费支出，不超过工资薪金总额14%的部分，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十一条
									企业拨缴的工会经费，不超过工资薪金总额2%的部分，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十二条
									除国务院财政、税务主管部门另有规定外，企业发生的职工教育经费支出，不超过工资薪金总额2.5%的部分，准予扣除；超过部分，准予在以后纳税年度结转扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十三条
									企业发生的与生产经营活动有关的业务招待费支出，按照发生额的60%扣除，但最高不得超过当年销售（营业）收入的5‰。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十四条
									企业发生的符合条件的广告费和业务宣传费支出，除国务院财政、税务主管部门另有规定外，不超过当年销售（营业）收入15%的部分，准予扣除；超过部分，准予在以后纳税年度结转扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十五条
									企业依照法律、行政法规有关规定提取的用于环境保护、生态恢复等方面的专项资金，准予扣除。上述专项资金提取后改变用途的，不得扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十六条
									企业参加财产保险，按照规定缴纳的保险费，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十七条
									企业根据生产经营活动的需要租入固定资产支付的租赁费，按照以下方法扣除：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）以经营租赁方式租入固定资产发生的租赁费支出，按照租赁期限均匀扣除；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）以融资租赁方式租入固定资产发生的租赁费支出，按照规定构成融资租入固定资产价值的部分应当提取折旧费用，分期扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十八条 企业发生的合理的劳动保护支出，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第四十九条
									企业之间支付的管理费、企业内营业机构之间支付的租金和特许权使用费，以及非银行企业内营业机构之间支付的利息，不得扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十条
									非居民企业在中国境内设立的机构、场所，就其中国境外总机构发生的与该机构、场所生产经营有关的费用，能够提供总机构出具的费用汇集范围、定额、分配依据和方法等证明文件，并合理分摊的，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十一条
									企业所得税法第九条所称公益性捐赠，是指企业通过公益性社会团体或者县级以上人民政府及其部门，用于《中华人民共和国公益事业捐赠法》规定的公益事业的捐赠。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十二条
									本条例第五十一条所称公益性社会团体，是指同时符合下列条件的基金会、慈善组织等社会团体：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）依法登记，具有法人资格；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）以发展公益事业为宗旨，且不以营利为目的；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）全部资产及其增值为该法人所有；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）收益和营运结余主要用于符合该法人设立目的的事业；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）终止后的剩余财产不归属任何个人或者营利组织；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（六）不经营与其设立目的无关的业务；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（七）有健全的财务会计制度；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（八）捐赠者不以任何形式参与社会团体财产的分配；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（九）国务院财政、税务主管部门会同国务院民政部门等登记管理部门规定的其他条件。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十三条
									企业发生的公益性捐赠支出，不超过年度利润总额12%的部分，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									年度利润总额，是指企业依照国家统一会计制度的规定计算的年度会计利润。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十四条
									企业所得税法第十条第（六）项所称赞助支出，是指企业发生的与生产经营活动无关的各种非广告性质支出。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十五条
									企业所得税法第十条第（七）项所称未经核定的准备金支出，是指不符合国务院财政、税务主管部门规定的各项资产减值准备、风险准备等准备金支出。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第四节 资产的税务处理</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十六条
									企业的各项资产，包括固定资产、生物资产、无形资产、长期待摊费用、投资资产、存货等，以历史成本为计税基础。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									前款所称历史成本，是指企业取得该项资产时实际发生的支出。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业持有各项资产期间资产增值或者减值，除国务院财政、税务主管部门规定可以确认损益外，不得调整该资产的计税基础。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十七条
									企业所得税法第十一条所称固定资产，是指企业为生产产品、提供劳务、出租或者经营管理而持有的、使用时间超过12个月的非货币性资产，包括房屋、建筑物、机器、机械、运输工具以及其他与生产经营活动有关的设备、器具、工具等。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十八条 固定资产按照以下方法确定计税基础：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）外购的固定资产，以购买价款和支付的相关税费以及直接归属于使该资产达到预定用途发生的其他支出为计税基础；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）自行建造的固定资产，以竣工结算前发生的支出为计税基础；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）融资租入的固定资产，以租赁合同约定的付款总额和承租人在签订租赁合同过程中发生的相关费用为计税基础，租赁合同未约定付款总额的，以该资产的公允价值和承租人在签订租赁合同过程中发生的相关费用为计税基础；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）盘盈的固定资产，以同类固定资产的重置完全价值为计税基础；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）通过捐赠、投资、非货币性资产交换、债务重组等方式取得的固定资产，以该资产的公允价值和支付的相关税费为计税基础；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（六）改建的固定资产，除企业所得税法第十三条第（一）项和第（二）项规定的支出外，以改建过程中发生的改建支出增加计税基础。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第五十九条 固定资产按照直线法计算的折旧，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业应当自固定资产投入使用月份的次月起计算折旧；停止使用的固定资产，应当自停止使用月份的次月起停止计算折旧。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业应当根据固定资产的性质和使用情况，合理确定固定资产的预计净残值。固定资产的预计净残值一经确定，不得变更。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十条
									除国务院财政、税务主管部门另有规定外，固定资产计算折旧的最低年限如下：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）房屋、建筑物，为20年；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）飞机、火车、轮船、机器、机械和其他生产设备，为10年；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）与生产经营活动有关的器具、工具、家具等，为5年；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）飞机、火车、轮船以外的运输工具，为4年；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）电子设备，为3年。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十一条
									从事开采石油、天然气等矿产资源的企业，在开始商业性生产前发生的费用和有关固定资产的折耗、折旧方法，由国务院财政、税务主管部门另行规定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十二条 生产性生物资产按照以下方法确定计税基础：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）外购的生产性生物资产，以购买价款和支付的相关税费为计税基础；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）通过捐赠、投资、非货币性资产交换、债务重组等方式取得的生产性生物资产，以该资产的公允价值和支付的相关税费为计税基础。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									前款所称生产性生物资产，是指企业为生产农产品、提供劳务或者出租等而持有的生物资产，包括经济林、薪炭林、产畜和役畜等。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十三条
									生产性生物资产按照直线法计算的折旧，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业应当自生产性生物资产投入使用月份的次月起计算折旧；停止使用的生产性生物资产，应当自停止使用月份的次月起停止计算折旧。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业应当根据生产性生物资产的性质和使用情况，合理确定生产性生物资产的预计净残值。生产性生物资产的预计净残值一经确定，不得变更。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十四条 生产性生物资产计算折旧的最低年限如下：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）林木类生产性生物资产，为10年；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）畜类生产性生物资产，为3年。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十五条
									企业所得税法第十二条所称无形资产，是指企业为生产产品、提供劳务、出租或者经营管理而持有的、没有实物形态的非货币性长期资产，包括专利权、商标权、著作权、土地使用权、非专利技术、商誉等。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十六条 无形资产按照以下方法确定计税基础：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）外购的无形资产，以购买价款和支付的相关税费以及直接归属于使该资产达到预定用途发生的其他支出为计税基础；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）自行开发的无形资产，以开发过程中该资产符合资本化条件后至达到预定用途前发生的支出为计税基础；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）通过捐赠、投资、非货币性资产交换、债务重组等方式取得的无形资产，以该资产的公允价值和支付的相关税费为计税基础。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十七条 无形资产按照直线法计算的摊销费用，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									无形资产的摊销年限不得低于10年。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									作为投资或者受让的无形资产，有关法律规定或者合同约定了使用年限的，可以按照规定或者约定的使用年限分期摊销。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									外购商誉的支出，在企业整体转让或者清算时，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十八条
									企业所得税法第十三条第（一）项和第（二）项所称固定资产的改建支出，是指改变房屋或者建筑物结构、延长使用年限等发生的支出。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第十三条第（一）项规定的支出，按照固定资产预计尚可使用年限分期摊销；第（二）项规定的支出，按照合同约定的剩余租赁期限分期摊销。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									改建的固定资产延长使用年限的，除企业所得税法第十三条第（一）项和第（二）项规定外，应当适当延长折旧年限。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第六十九条
									企业所得税法第十三条第（三）项所称固定资产的大修理支出，是指同时符合下列条件的支出：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）修理支出达到取得固定资产时的计税基础50%以上；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）修理后固定资产的使用年限延长2年以上。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第十三条第（三）项规定的支出，按照固定资产尚可使用年限分期摊销。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十条
									企业所得税法第十三条第（四）项所称其他应当作为长期待摊费用的支出，自支出发生月份的次月起，分期摊销，摊销年限不得低于3年。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十一条
									企业所得税法第十四条所称投资资产，是指企业对外进行权益性投资和债权性投资形成的资产。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业在转让或者处置投资资产时，投资资产的成本，准予扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									投资资产按照以下方法确定成本：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）通过支付现金方式取得的投资资产，以购买价款为成本；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）通过支付现金以外的方式取得的投资资产，以该资产的公允价值和支付的相关税费为成本。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十二条
									企业所得税法第十五条所称存货，是指企业持有以备出售的产品或者商品、处在生产过程中的在产品、在生产或者提供劳务过程中耗用的材料和物料等。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									存货按照以下方法确定成本：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）通过支付现金方式取得的存货，以购买价款和支付的相关税费为成本；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）通过支付现金以外的方式取得的存货，以该存货的公允价值和支付的相关税费为成本；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）生产性生物资产收获的农产品，以产出或者采收过程中发生的材料费、人工费和分摊的间接费用等必要支出为成本。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十三条
									企业使用或者销售的存货的成本计算方法，可以在先进先出法、加权平均法、个别计价法中选用一种。计价方法一经选用，不得随意变更。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十四条
									企业所得税法第十六条所称资产的净值和第十九条所称财产净值，是指有关资产、财产的计税基础减除已经按照规定扣除的折旧、折耗、摊销、准备金等后的余额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十五条
									除国务院财政、税务主管部门另有规定外，企业在重组过程中，应当在交易发生时确认有关资产的转让所得或者损失，相关资产应当按照交易价格重新确定计税基础。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第三章 应纳税额</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十六条
									企业所得税法第二十二条规定的应纳税额的计算公式为：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									应纳税额＝应纳税所得额×适用税率－减免税额－抵免税额</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									公式中的减免税额和抵免税额，是指依照企业所得税法和国务院的税收优惠规定减征、免征和抵免的应纳税额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十七条
									企业所得税法第二十三条所称已在境外缴纳的所得税税额，是指企业来源于中国境外的所得依照中国境外税收法律以及相关规定应当缴纳并已经实际缴纳的企业所得税性质的税款。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十八条
									企业所得税法第二十三条所称抵免限额，是指企业来源于中国境外的所得，依照企业所得税法和本条例的规定计算的应纳税额。除国务院财政、税务主管部门另有规定外，该抵免限额应当分国（地区）不分项计算，计算公式如下：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									抵免限额＝中国境内、境外所得依照企业所得税法和本条例的规定计算的应纳税总额×来源于某国（地区）的应纳税所得额÷中国境内、境外应纳税所得总额</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第七十九条
									企业所得税法第二十三条所称5个年度，是指从企业取得的来源于中国境外的所得，已经在中国境外缴纳的企业所得税性质的税额超过抵免限额的当年的次年起连续5个纳税年度。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十条
									企业所得税法第二十四条所称直接控制，是指居民企业直接持有外国企业20%以上股份。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第二十四条所称间接控制，是指居民企业以间接持股方式持有外国企业20%以上股份，具体认定办法由国务院财政、税务主管部门另行制定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十一条
									企业依照企业所得税法第二十三条、第二十四条的规定抵免企业所得税税额时，应当提供中国境外税务机关出具的税款所属年度的有关纳税凭证。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第四章 税收优惠</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十二条
									企业所得税法第二十六条第（一）项所称国债利息收入，是指企业持有国务院财政部门发行的国债取得的利息收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十三条
									企业所得税法第二十六条第（二）项所称符合条件的居民企业之间的股息、红利等权益性投资收益，是指居民企业直接投资于其他居民企业取得的投资收益。企业所得税法第二十六条第（二）项和第（三）项所称股息、红利等权益性投资收益，不包括连续持有居民企业公开发行并上市流通的股票不足12个月取得的投资收益。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十四条
									企业所得税法第二十六条第（四）项所称符合条件的非营利组织，是指同时符合下列条件的组织：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）依法履行非营利组织登记手续；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）从事公益性或者非营利性活动；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）取得的收入除用于与该组织有关的、合理的支出外，全部用于登记核定或者章程规定的公益性或者非营利性事业；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）财产及其孳息不用于分配；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）按照登记核定或者章程规定，该组织注销后的剩余财产用于公益性或者非营利性目的，或者由登记管理机关转赠给与该组织性质、宗旨相同的组织，并向社会公告；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（六）投入人对投入该组织的财产不保留或者享有任何财产权利；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（七）工作人员工资福利开支控制在规定的比例内，不变相分配该组织的财产。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									前款规定的非营利组织的认定管理办法由国务院财政、税务主管部门会同国务院有关部门制定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十五条
									企业所得税法第二十六条第（四）项所称符合条件的非营利组织的收入，不包括非营利组织从事营利性活动取得的收入，但国务院财政、税务主管部门另有规定的除外。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十六条
									企业所得税法第二十七条第（一）项规定的企业从事农、林、牧、渔业项目的所得，可以免征、减征企业所得税，是指：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）企业从事下列项目的所得，免征企业所得税：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									1.蔬菜、谷物、薯类、油料、豆类、棉花、麻类、糖料、水果、坚果的种植；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									2.农作物新品种的选育；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 3.中药材的种植；</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 4.林木的培育和种植；</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 5.牲畜、家禽的饲养；</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 6.林产品的采集；</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									7.灌溉、农产品初加工、兽医、农技推广、农机作业和维修等农、林、牧、渔服务业项目；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 8.远洋捕捞。</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）企业从事下列项目的所得，减半征收企业所得税：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									1.花卉、茶以及其他饮料作物和香料作物的种植；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									2.海水养殖、内陆养殖。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业从事国家限制和禁止发展的项目，不得享受本条规定的企业所得税优惠。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十七条
									企业所得税法第二十七条第（二）项所称国家重点扶持的公共基础设施项目，是指《公共基础设施项目企业所得税优惠目录》规定的港口码头、机场、铁路、公路、城市公共交通、电力、水利等项目。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业从事前款规定的国家重点扶持的公共基础设施项目的投资经营的所得，自项目取得第一笔生产经营收入所属纳税年度起，第一年至第三年免征企业所得税，第四年至第六年减半征收企业所得税。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业承包经营、承包建设和内部自建自用本条规定的项目，不得享受本条规定的企业所得税优惠。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十八条
									企业所得税法第二十七条第（三）项所称符合条件的环境保护、节能节水项目，包括公共污水处理、公共垃圾处理、沼气综合开发利用、节能减排技术改造、海水淡化等。项目的具体条件和范围由国务院财政、税务主管部门商国务院有关部门制订，报国务院批准后公布施行。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业从事前款规定的符合条件的环境保护、节能节水项目的所得，自项目取得第一笔生产经营收入所属纳税年度起，第一年至第三年免征企业所得税，第四年至第六年减半征收企业所得税。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第八十九条
									依照本条例第八十七条和第八十八条规定享受减免税优惠的项目，在减免税期限内转让的，受让方自受让之日起，可以在剩余期限内享受规定的减免税优惠；减免税期限届满后转让的，受让方不得就该项目重复享受减免税优惠。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十条
									企业所得税法第二十七条第（四）项所称符合条件的技术转让所得免征、减征企业所得税，是指一个纳税年度内，居民企业技术转让所得不超过500万元的部分，免征企业所得税；超过500万元的部分，减半征收企业所得税。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十一条
									非居民企业取得企业所得税法第二十七条第（五）项规定的所得，减按10%的税率征收企业所得税。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									下列所得可以免征企业所得税：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）外国政府向中国政府提供贷款取得的利息所得；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）国际金融组织向中国政府和居民企业提供优惠贷款取得的利息所得；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）经国务院批准的其他所得。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十二条
									企业所得税法第二十八条第一款所称符合条件的小型微利企业，是指从事国家非限制和禁止行业，并符合下列条件的企业：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）工业企业，年度应纳税所得额不超过30万元，从业人数不超过100人，资产总额不超过3000万元；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）其他企业，年度应纳税所得额不超过30万元，从业人数不超过80人，资产总额不超过1000万元。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十三条
									企业所得税法第二十八条第二款所称国家需要重点扶持的高新技术企业，是指拥有核心自主知识产权，并同时符合下列条件的企业：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）产品（服务）属于《国家重点支持的高新技术领域》规定的范围；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）研究开发费用占销售收入的比例不低于规定比例；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）高新技术产品（服务）收入占企业总收入的比例不低于规定比例；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）科技人员占企业职工总数的比例不低于规定比例；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）高新技术企业认定管理办法规定的其他条件。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									《国家重点支持的高新技术领域》和高新技术企业认定管理办法由国务院科技、财政、税务主管部门商国务院有关部门制订，报国务院批准后公布施行。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十四条
									企业所得税法第二十九条所称民族自治地方，是指依照《中华人民共和国民族区域自治法》的规定，实行民族区域自治的自治区、自治州、自治县。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									对民族自治地方内国家限制和禁止行业的企业，不得减征或者免征企业所得税。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十五条
									企业所得税法第三十条第（一）项所称研究开发费用的加计扣除，是指企业为开发新技术、新产品、新工艺发生的研究开发费用，未形成无形资产计入当期损益的，在按照规定据实扣除的基础上，按照研究开发费用的50%加计扣除；形成无形资产的，按照无形资产成本的150%摊销。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十六条
									企业所得税法第三十条第（二）项所称企业安置残疾人员所支付的工资的加计扣除，是指企业安置残疾人员的，在按照支付给残疾职工工资据实扣除的基础上，按照支付给残疾职工工资的100%加计扣除。残疾人员的范围适用《中华人民共和国残疾人保障法》的有关规定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第三十条第（二）项所称企业安置国家鼓励安置的其他就业人员所支付的工资的加计扣除办法，由国务院另行规定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十七条
									企业所得税法第三十一条所称抵扣应纳税所得额，是指创业投资企业采取股权投资方式投资于未上市的中小高新技术企业2年以上的，可以按照其投资额的70%在股权持有满2年的当年抵扣该创业投资企业的应纳税所得额；当年不足抵扣的，可以在以后纳税年度结转抵扣。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十八条
									企业所得税法第三十二条所称可以采取缩短折旧年限或者采取加速折旧的方法的固定资产，包括：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）由于技术进步，产品更新换代较快的固定资产；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）常年处于强震动、高腐蚀状态的固定资产。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									采取缩短折旧年限方法的，最低折旧年限不得低于本条例第六十条规定折旧年限的60%；采取加速折旧方法的，可以采取双倍余额递减法或者年数总和法。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第九十九条
									企业所得税法第三十三条所称减计收入，是指企业以《资源综合利用企业所得税优惠目录》规定的资源作为主要原材料，生产国家非限制和禁止并符合国家和行业相关标准的产品取得的收入，减按90%计入收入总额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									前款所称原材料占生产产品材料的比例不得低于《资源综合利用企业所得税优惠目录》规定的标准。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百条
									企业所得税法第三十四条所称税额抵免，是指企业购置并实际使用《环境保护专用设备企业所得税优惠目录》、《节能节水专用设备企业所得税优惠目录》和《安全生产专用设备企业所得税优惠目录》规定的环境保护、节能节水、安全生产等专用设备的，该专用设备的投资额的10%可以从企业当年的应纳税额中抵免；当年不足抵免的，可以在以后5个纳税年度结转抵免。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									享受前款规定的企业所得税优惠的企业，应当实际购置并自身实际投入使用前款规定的专用设备；企业购置上述专用设备在5年内转让、出租的，应当停止享受企业所得税优惠，并补缴已经抵免的企业所得税税款。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百零一条
									本章第八十七条、第九十九条、第一百条规定的企业所得税优惠目录，由国务院财政、税务主管部门商国务院有关部门制订，报国务院批准后公布施行。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百零二条
									企业同时从事适用不同企业所得税待遇的项目的，其优惠项目应当单独计算所得，并合理分摊企业的期间费用；没有单独计算的，不得享受企业所得税优惠。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第五章 源泉扣缴</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百零三条
									依照企业所得税法对非居民企业应当缴纳的企业所得税实行源泉扣缴的，应当依照企业所得税法第十九条的规定计算应纳税所得额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第十九条所称收入全额，是指非居民企业向支付人收取的全部价款和价外费用。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百零四条
									企业所得税法第三十七条所称支付人，是指依照有关法律规定或者合同约定对非居民企业直接负有支付相关款项义务的单位或者个人。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百零五条
									企业所得税法第三十七条所称支付，包括现金支付、汇拨支付、转账支付和权益兑价支付等货币支付和非货币支付。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第三十七条所称到期应支付的款项，是指支付人按照权责发生制原则应当计入相关成本、费用的应付款项。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百零六条
									企业所得税法第三十八条规定的可以指定扣缴义务人的情形，包括：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）预计工程作业或者提供劳务期限不足一个纳税年度，且有证据表明不履行纳税义务的；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）没有办理税务登记或者临时税务登记，且未委托中国境内的代理人履行纳税义务的；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）未按照规定期限办理企业所得税纳税申报或者预缴申报的。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									前款规定的扣缴义务人，由县级以上税务机关指定，并同时告知扣缴义务人所扣税款的计算依据、计算方法、扣缴期限和扣缴方式。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百零七条
									企业所得税法第三十九条所称所得发生地，是指依照本条例第七条规定的原则确定的所得发生地。在中国境内存在多处所得发生地的，由纳税人选择其中之一申报缴纳企业所得税。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百零八条
									企业所得税法第三十九条所称该纳税人在中国境内其他收入，是指该纳税人在中国境内取得的其他各种来源的收入。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									税务机关在追缴该纳税人应纳税款时，应当将追缴理由、追缴数额、缴纳期限和缴纳方式等告知该纳税人。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第六章 特别纳税调整</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百零九条
									企业所得税法第四十一条所称关联方，是指与企业有下列关联关系之一的企业、其他组织或者个人：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）在资金、经营、购销等方面存在直接或者间接的控制关系；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）直接或者间接地同为第三者控制；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）在利益上具有相关联的其他关系。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十条
									企业所得税法第四十一条所称独立交易原则，是指没有关联关系的交易各方，按照公平成交价格和营业常规进行业务往来遵循的原则。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十一条
									企业所得税法第四十一条所称合理方法，包括：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）可比非受控价格法，是指按照没有关联关系的交易各方进行相同或者类似业务往来的价格进行定价的方法；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）再销售价格法，是指按照从关联方购进商品再销售给没有关联关系的交易方的价格，减除相同或者类似业务的销售毛利进行定价的方法；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）成本加成法，是指按照成本加合理的费用和利润进行定价的方法；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）交易净利润法，是指按照没有关联关系的交易各方进行相同或者类似业务往来取得的净利润水平确定利润的方法；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）利润分割法，是指将企业与其关联方的合并利润或者亏损在各方之间采用合理标准进行分配的方法；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（六）其他符合独立交易原则的方法。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十二条
									企业可以依照企业所得税法第四十一条第二款的规定，按照独立交易原则与其关联方分摊共同发生的成本，达成成本分摊协议。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业与其关联方分摊成本时，应当按照成本与预期收益相配比的原则进行分摊，并在税务机关规定的期限内，按照税务机关的要求报送有关资料。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业与其关联方分摊成本时违反本条第一款、第二款规定的，其自行分摊的成本不得在计算应纳税所得额时扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十三条
									企业所得税法第四十二条所称预约定价安排，是指企业就其未来年度关联交易的定价原则和计算方法，向税务机关提出申请，与税务机关按照独立交易原则协商、确认后达成的协议。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十四条
									企业所得税法第四十三条所称相关资料，包括：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）与关联业务往来有关的价格、费用的制定标准、计算方法和说明等同期资料；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）关联业务往来所涉及的财产、财产使用权、劳务等的再销售（转让）价格或者最终销售（转让）价格的相关资料；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）与关联业务调查有关的其他企业应当提供的与被调查企业可比的产品价格、定价方式以及利润水平等资料；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）其他与关联业务往来有关的资料。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第四十三条所称与关联业务调查有关的其他企业，是指与被调查企业在生产经营内容和方式上相类似的企业。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业应当在税务机关规定的期限内提供与关联业务往来有关的价格、费用的制定标准、计算方法和说明等资料。关联方以及与关联业务调查有关的其他企业应当在税务机关与其约定的期限内提供相关资料。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十五条
									税务机关依照企业所得税法第四十四条的规定核定企业的应纳税所得额时，可以采用下列方法：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）参照同类或者类似企业的利润率水平核定；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）按照企业成本加合理的费用和利润的方法核定；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）按照关联企业集团整体利润的合理比例核定；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）按照其他合理方法核定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业对税务机关按照前款规定的方法核定的应纳税所得额有异议的，应当提供相关证据，经税务机关认定后，调整核定的应纳税所得额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十六条
									企业所得税法第四十五条所称中国居民，是指根据《中华人民共和国个人所得税法》的规定，就其从中国境内、境外取得的所得在中国缴纳个人所得税的个人。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十七条 企业所得税法第四十五条所称控制，包括：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）居民企业或者中国居民直接或者间接单一持有外国企业10%以上有表决权股份，且由其共同持有该外国企业50%以上股份；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）居民企业，或者居民企业和中国居民持股比例没有达到第（一）项规定的标准，但在股份、资金、经营、购销等方面对该外国企业构成实质控制。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十八条
									企业所得税法第四十五条所称实际税负明显低于企业所得税法第四条第一款规定税率水平，是指低于企业所得税法第四条第一款规定税率的50%.</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百一十九条
									企业所得税法第四十六条所称债权性投资，是指企业直接或者间接从关联方获得的，需要偿还本金和支付利息或者需要以其他具有支付利息性质的方式予以补偿的融资。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业间接从关联方获得的债权性投资，包括：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）关联方通过无关联第三方提供的债权性投资；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）无关联第三方提供的、由关联方担保且负有连带责任的债权性投资；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）其他间接从关联方获得的具有负债实质的债权性投资。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第四十六条所称权益性投资，是指企业接受的不需要偿还本金和支付利息，投资人对企业净资产拥有所有权的投资。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业所得税法第四十六条所称标准，由国务院财政、税务主管部门另行规定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十条
									企业所得税法第四十七条所称不具有合理商业目的，是指以减少、免除或者推迟缴纳税款为主要目的。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十一条
									税务机关根据税收法律、行政法规的规定，对企业作出特别纳税调整的，应当对补征的税款，自税款所属纳税年度的次年6月1日起至补缴税款之日止的期间，按日加收利息。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									前款规定加收的利息，不得在计算应纳税所得额时扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十二条
									企业所得税法第四十八条所称利息，应当按照税款所属纳税年度中国人民银行公布的与补税期间同期的人民币贷款基准利率加5个百分点计算。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业依照企业所得税法第四十三条和本条例的规定提供有关资料的，可以只按前款规定的人民币贷款基准利率计算利息。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十三条
									企业与其关联方之间的业务往来，不符合独立交易原则，或者企业实施其他不具有合理商业目的安排的，税务机关有权在该业务发生的纳税年度起10年内，进行纳税调整。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第七章 征收管理</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十四条
									企业所得税法第五十条所称企业登记注册地，是指企业依照国家有关规定登记注册的住所地。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十五条
									企业汇总计算并缴纳企业所得税时，应当统一核算应纳税所得额，具体办法由国务院财政、税务主管部门另行制定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十六条
									企业所得税法第五十一条所称主要机构、场所，应当同时符合下列条件：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）对其他各机构、场所的生产经营活动负有监督管理责任；</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）设有完整的账簿、凭证，能够准确反映各机构、场所的收入、成本、费用和盈亏情况。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十七条
									企业所得税法第五十一条所称经税务机关审核批准，是指经各机构、场所所在地税务机关的共同上级税务机关审核批准。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									非居民企业经批准汇总缴纳企业所得税后，需要增设、合并、迁移、关闭机构、场所或者停止机构、场所业务的，应当事先由负责汇总申报缴纳企业所得税的主要机构、场所向其所在地税务机关报告；需要变更汇总缴纳企业所得税的主要机构、场所的，依照前款规定办理。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十八条
									企业所得税分月或者分季预缴，由税务机关具体核定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业根据企业所得税法第五十四条规定分月或者分季预缴企业所得税时，应当按照月度或者季度的实际利润额预缴；按照月度或者季度的实际利润额预缴有困难的，可以按照上一纳税年度应纳税所得额的月度或者季度平均额预缴，或者按照经税务机关认可的其他方法预缴。预缴方法一经确定，该纳税年度内不得随意变更。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百二十九条
									企业在纳税年度内无论盈利或者亏损，都应当依照企业所得税法第五十四条规定的期限，向税务机关报送预缴企业所得税纳税申报表、年度企业所得税纳税申报表、财务会计报告和税务机关规定应当报送的其他有关资料。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百三十条
									企业所得以人民币以外的货币计算的，预缴企业所得税时，应当按照月度或者季度最后一日的人民币汇率中间价，折合成人民币计算应纳税所得额。年度终了汇算清缴时，对已经按照月度或者季度预缴税款的，不再重新折合计算，只就该纳税年度内未缴纳企业所得税的部分，按照纳税年度最后一日的人民币汇率中间价，折合成人民币计算应纳税所得额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									经税务机关检查确认，企业少计或者多计前款规定的所得的，应当按照检查确认补税或者退税时的上一个月最后一日的人民币汇率中间价，将少计或者多计的所得折合成人民币计算应纳税所得额，再计算应补缴或者应退的税款。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 第八章 附 则</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百三十一条
									企业所得税法第五十七条第一款所称本法公布前已经批准设立的企业，是指企业所得税法公布前已经完成登记注册的企业。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百三十二条
									在香港特别行政区、澳门特别行政区和台湾地区成立的企业，参照适用企业所得税法第二条第二款、第三款的有关规定。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									第一百三十三条
									本条例自2008年1月1日起施行。1991年6月30日国务院发布的《中华人民共和国外商投资企业和外国企业所得税法实施细则》和1994年2月4日财政部发布的《中华人民共和国企业所得税暂行条例实施细则》同时废止。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
			</div>
		</div>
	</app-page>
</template>
<script>
import AppPage from "@/components/semantics/AppPage.vue";

export default {
	components: {
		AppPage
	},
	methods: {
		goback() {
			this.$router.go(-1);
		}
	}
};
</script>